import React, { useState, useEffect, useMemo } from 'react'
import { connect } from "react-redux"
import TopBarNav from '../common/TopBarNav'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { useHistory } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import * as collateralActions from '../../actions/collateral/CollateralActions'
import { downloadCSVCustomName, getTableColumnsByStage } from "../common/Utils"
import { CollateralStyles } from './CollateralStyles'
import TableFilterComponentCollateralTelematics from '../common/TableFilterComponentCollateralTelematics'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import { customStylePrincipal, customStylePrincipalAP } from '../common/CommonStyles'
import Constants from '../common/Constants.json'

const CollateralListByStatus = ({ classes, ...props }) => {
    const history = useHistory()
    const [filterText, setFilterText] = useState('')
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const { match: { params } } = props
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t } = useTranslation()

    const status = params.stage === 'ProcesoATiempo' ||
        params.stage === 'ProcesoFueraDeTiempo' ||
        params.stage === 'Tramite' ? 'orderDays' : 'woStatus'

    const excelConfigurationPaidAndRejected = [
        {
            selector: 'woid',
            label: t('common.woid')
        },
        {
            selector: 'invoicestatus',
            label: t('common.status')
        },
        {
            selector: 'createdDate',
            label: t('common.assignedDate')
        },
        {
            selector: 'invoicenumber',
            label: t('collateralColumns.Folio Factura')
        },
        {
            selector: 'uuid',
            label: t('collateralColumns.uuid')
        },
        {
            selector: 'totalamount',
            label: t('collateralColumns.Importe Factura')
        },
        {
            selector: 'vinNumber',
            label: t('collateralColumns.VIN')
        },
        {
            selector: 'fleet',
            label: t('common.fleet')
        },
        {
            selector: 'fechapagorechazo',
            label: t('collateralColumns.Fecha pago rechazo')
        },
        {
            selector: 'numerodocumentopago',
            label: t('collateralColumns.Numero documento de pago')
        }
    ]

    const excelConfigurationPendientPayment = [
        {
            selector: 'woid',
            label: t('common.woid')
        },
        {
            selector: 'invoicenumber',
            label: t('collateralColumns.Folio Factura')
        },
        {
            selector: 'uuid',
            label: t('collateralColumns.uuid')
        },
        {
            selector: 'totalamount',
            label: t('collateralColumns.Importe Factura')
        },
        {
            selector: 'vinNumber',
            label: t('collateralColumns.VIN')
        },
        {
            selector: 'fleet',
            label: t('common.fleet')
        }
    ]

    const excelConfigurationAlter = [
        {
            selector: 'urgentWO',
            label: t('common.urgentWOID')
        },
        {
            selector: 'idXcelerate',
            label: t('ID Xcelerate')
        },
        {
            selector: 'woid',
            label: t('common.woid')
        },
        {
            selector: status,
            label: t('common.status')
        },
        {
            selector: 'make',
            label: t('common.make')
        },
        {
            selector: 'modelCar',
            label: t('collateralColumns.Modelo')
        },
        {
            selector: 'plate',
            label: t('collateralColumns.Placas')
        },
        {
            selector: 'procedureStates',
            label: t('common.statesWOID')
        },
                {
            selector: 'procedures',
            label: t('common.proceduresWOID')
        },
        {
            selector: 'vinNumber',
            label: t('collateralColumns.VIN')
        },
        {
            selector: 'assignedArea',
            label: t('collateralColumns.assignedArea')
        },
        {
            selector: 'assignedUser',
            label: t('collateralColumns.assignedUser')
        },
        {
            selector: 'assignedSupplierDate',
            label: t('common.assignedDate')
        },
        {
            selector: 'fleet',
            label: t('common.fleet')
        },
        {
            selector: 'unitNumber',
            label: t('common.unit')
        },
        {
            selector: 'supplierName',
            label: t('common.supplierName')
        }
    ]

    const excelConfiguration = [
        {
            selector: 'urgentWO',
            label: t('common.urgentWOID')
        },
        {
            selector: 'idXcelerate',
            label: t('ID Xcelerate')
        },
        {
            selector: 'woid',
            label: t('common.woid')
        },
        {
            selector: status,
            label: t('common.status')
        },
        {
            selector: 'make',
            label: t('common.make')
        },
        {
            selector: 'modelCar',
            label: t('collateralColumns.Modelo')
        },
        {
            selector: 'plate',
            label: t('collateralColumns.Placas')
        },
                {
            selector: 'procedureStates',
            label: t('common.statesWOID')
        },
                {
            selector: 'procedures',
            label: t('common.proceduresWOID')
        },
        {
            selector: 'vinNumber',
            label: t('collateralColumns.VIN')
        },
        {
            selector: 'assignedArea',
            label: t('collateralColumns.assignedArea')
        },
        {
            selector: 'assignedUser',
            label: t('collateralColumns.assignedUser')
        },
        {
            selector: 'assignedSupplierDate',
            label: t('common.assignedDate')
        },
        {
            selector: 'endDate',
            label: t('common.endDate')
        },
        {
            selector: 'fleet',
            label: t('common.fleet')
        },
        {
            selector: 'unitNumber',
            label: t('common.unit')
        },
        {
            selector: 'supplierName',
            label: t('common.supplierName')
        }
    ]

    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    useEffect(() => {
        const newRoute = {
            path: '/collateral/listByStatus',
            linkLegend: t(`collateralDashboard.${params.stage}`),
            urlParams: [{ key: 'stage', value: params.stage }, { key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)
        if (filterText.length === 0 || filterText.length >= 5) {
            handleOpenBackdrop()
            props.actions.fetch_oc_by_filter(props.userLanguage, props.userToken, startDate, endDate, filterText, params.stage, params.branchOfficeId, onError, onSuccess)
            props.cleanUserProfile()
        }
    }, [filterText]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    alert(t('commonMessages.alert500'))
                    break
                default:
                    break
            }
        }
    }

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            setFilterText('')
        }

        const handleStartDateChange = (e) => {
            if (e != null)
                setStartDate(e.format('YYYY-MM-DD'))
            else
                setStartDate(null)
        }

        const handleEndDateChange = (e) => {
            if (e != null)
                setEndDate(e.format('YYYY-MM-DD'))
            else
                setEndDate(null)
        }

        const handleDateSearch = () => {
            handleOpenBackdrop()
            props.actions.fetch_oc_by_filter(props.userLanguage, props.userToken, startDate, endDate, filterText, params.stage, params.branchOfficeId, onError, onSuccess)
        }

        const handlerSearchByText = () => {
            handleOpenBackdrop()
            props.actions.fetch_oc_by_filter(props.userLanguage, props.userToken, startDate, endDate, filterText, params.stage, params.branchOfficeId, onError, onSuccess)
            props.cleanUserProfile()
        }
        const selectConfig = (stage) => {
            switch(stage){
                case 'ProcesoFueraDeTiempo':
                case 'ProcesoATiempo':
                    return excelConfigurationAlter;
                case 'Finalizacion':
                    return excelConfigurationPaidAndRejected;
                case 'PagoPendiente':
                    return excelConfigurationPendientPayment;
                default:
                    return excelConfiguration;
            }                
        }
        const selectName = (stage) => {
            switch(stage){
                case 'ProcesoFueraDeTiempo':
                case 'ProcesoATiempo':
                    return ('export');
                case 'Finalizacion':
                    return ('Pagadas_rechazadas');
                case 'PagoPendiente':
                    return ('Pago_pendiente');
                default:
                    return ('export');
        }                
        }

        return <TableFilterComponentCollateralTelematics
            onFilter={e => setFilterText(e.target.value)}
            onClear={handleClear} filterText={filterText}
            onclickSearchByText={handlerSearchByText}
            onStartDateChange={handleStartDateChange}
            onEndDateChange={handleEndDateChange}
            onClickSearch={handleDateSearch}
            //onExport={() => downloadCSV(props.listByStatus, params.stage === 'ProcesoFueraDeTiempo' || params.stage === 'ProcesoATiempo' || params.stage === 'Finalizacion' ? excelConfigurationAlter : excelConfiguration)}
            onExport={() => downloadCSVCustomName(props.listByStatus, selectConfig(params.stage), selectName(params.stage))}
            styles={classes.searchAlign}
        />;
    }, [filterText, props]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}></Grid>
                </Grid>
                <Grid >
                    {
                        params.stage && params.stage === 'Tramite' && (
                            <p className={classes.tableTitleAP}>{t(`collateralDashboard.${params.stage}`)}</p>
                        )
                    }
                    <DataTable                        
                        title={params.stage === 'Tramite' ? <p style={{ fontWeight: '600' }}>{Constants.LegendsForAP.paymentStatusGestorias}</p> : t(`collateralDashboard.${params.stage}`)}
                        columns={getTableColumnsByStage("Collateral", params.stage, i18n.language)}
                        data={props.listByStatus}
                        defaultSortField="woid"
                        customStyles={params.stage === 'Tramite' ? customStylePrincipalAP : customStylePrincipal}
                        highlightOnHover
                        dense
                        responsive
                        striped
                        pointerOnHover
                        pagination
                        paginationComponentOptions={paginationOptions}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                    />
                </Grid>
                <br />
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    listByStatus: state.CollateralReducer.listOrders,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(collateralActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CollateralStyles)(CollateralListByStatus))